import React from 'react';
import { NavLink } from 'react-router-dom';
import Switcher from '../Elements/Switcher';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations, getByPath, resolveMediaSrc } from '../../content/siteContentUtils';

var defaultLogo = require('./../../images/LogoYatay.png');

class Footer extends React.Component {
    static contextType = SiteContentContext;

    render() {
        const content = this.context?.content || {};
        const t = getTranslations(content);
        const footerText = t?.footer || {};
        const contact = getByPath(content, 'contact', {});
        const phones = Array.isArray(contact.phones) ? contact.phones : [];
        const social = getByPath(content, 'social', {});
        const instagramUrl = (
            social.instagram &&
            social.instagram.trim() &&
            social.instagram.trim() !== 'https://www.instagram.com'
                ? social.instagram.trim()
                : 'https://www.instagram.com/fck_celik_kapi/'
        );
        const facebookUrl = (
            social.facebook &&
            social.facebook.trim() &&
            social.facebook.trim() !== 'https://www.facebook.com'
                ? social.facebook.trim()
                : 'https://www.facebook.com/profile.php?id=100066578837590'
        );
        const logoSrc = resolveMediaSrc(getByPath(content, 'media.logoUrl', ''), defaultLogo);
        const addressInline = Array.isArray(contact.addressLines) ? contact.addressLines.join(', ') : '';
        const catalogUrl = (getByPath(content, 'media.catalogPdfUrl', '') || '').trim();
        const referencesUrl = (getByPath(content, 'media.referencesPdfUrl', '') || '').trim();

        return (
            <>
                <footer className="site-footer footer-large footer-dark footer-wide">
                    <div className="footer-top overlay-wraper">
                        <div className="overlay-main" />
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="widget widget_about">
                                        <div className="logo-footer clearfix p-b15">
                                            <NavLink to={'/'}>
                                                <img src={logoSrc} alt="Fırat Çelik Kapı" style={{ maxWidth: '200px' }} />
                                            </NavLink>
                                        </div>
                                        <p>{footerText.companyDescription || ''}</p>
                                        <ul className="social-icons sx-social-links">
                                            <li><a href={facebookUrl} className="fa fa-facebook" target="_blank" rel="noreferrer"></a></li>
                                            <li><a href={instagramUrl} className="fa fa-instagram" target="_blank" rel="noreferrer"></a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6 col-sm-6 footer-col-3">
                                    <div className="widget widget_services inline-links">
                                        <h5 className="widget-title">{footerText.usefulLinksTitle || 'Faydalı Linkler'}</h5>
                                        <ul>
                                            <li><NavLink to={'/hakkimizda'}>Hakkımızda</NavLink></li>
                                            <li>
                                                <a
                                                    href={catalogUrl || '#'}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    onClick={(event) => {
                                                        if (!catalogUrl) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                >
                                                    {footerText.catalogLabel || 'Katalog'}
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href={referencesUrl || '#'}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    onClick={(event) => {
                                                        if (!referencesUrl) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                >
                                                    {footerText.referencesLabel || 'Referanslar'}
                                                </a>
                                            </li>
                                            <li><NavLink to={'/iletisim'}>İletişim</NavLink></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6 col-sm-6 footer-col-3">
                                    <div className="widget widget_services inline-links">
                                        <h5 className="widget-title">{footerText.productsTitle || 'Ürünlerimiz'}</h5>
                                        <ul>
                                            <li><NavLink to={'/daire-giris-kapilari'}>Daire Giriş Kapıları</NavLink></li>
                                            <li><NavLink to={'/villa-kapi-modelleri'}>Villa Kapı Modelleri</NavLink></li>
                                            <li><NavLink to={'/bina-giris-kapilari'}>Bina Giriş Kapıları</NavLink></li>
                                            <li><NavLink to={'/ic-kapilar'}>İç Kapılar</NavLink></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="widget widget_address_outer">
                                        <h5 className="widget-title">{footerText.contactTitle || 'Bize Ulaşın'}</h5>
                                        <ul className="widget_address">
                                            <li>{addressInline}</li>
                                            <li>{contact?.workingHours?.weekdays} | {contact?.workingHours?.sunday}</li>
                                            <li>{contact.email}</li>
                                            {phones.map((phone, index) => (
                                                <li key={`footer-phone-${index}`}>{phone}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer-bottom overlay-wraper">
                        <div className="overlay-main" />
                        <div className="container">
                            <div className="row">
                                <div className="sx-footer-bot-left">
                                    <span className="copyrights-text">{footerText.copyright || '© 2026 Optimum Ajans'}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                <Switcher />
            </>
        );
    };
};

export default Footer;
